import { useEffect, useState } from "react";
import api from "@/lib/api";

// Module-level cache so every card shares one /categories fetch.
let cache = null;
let inflight = null;

export function loadCategoryMeta() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api
      .get("/categories")
      .then((r) => {
        cache = {};
        (r.data || []).forEach((c) => { if (c.name) cache[c.name.trim().toLowerCase()] = c; });
        return cache;
      })
      .catch(() => (cache = {}));
  }
  return inflight;
}

export function useCategoryMeta() {
  const [meta, setMeta] = useState(cache || {});
  useEffect(() => { loadCategoryMeta().then((m) => setMeta({ ...m })); }, []);
  return meta;
}

export function categoryIconName(meta, category) {
  if (!category) return "Tag";
  const c = meta[category.trim().toLowerCase()];
  return (c && c.icon) || "Tag";
}
